<ngb-toast
  #toast
  (hidden)="toastService.remove(toast)"
  *ngFor="let toast of toastService.toasts"
  [autohide]="toast.toastType !== 'interactive'"
  [delay]="toast.delay"
  [header]="toast.header"
  [ngClass]="toast.toastType"
>
  {{ toast.body }}
  <ng-container *ngIf="toast.toastType === 'interactive'">
    <form class="mt-1">
      <div class="input-group">
        <button (click)="proceed(toast.callback)" class="btn btn-primary">
          Fortfahren
        </button>
        <button (click)="hide()" class="btn btn-primary">Abbrechen</button>
      </div>
    </form>
  </ng-container>
</ngb-toast>
